var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1C2.44772 1 2 1.44772 2 2V14C2 14.5523 2.44772 15 3 15H5C5.55228 15 6 14.5523 6 14V2C6 1.44772 5.55228 1 5 1H3Z",
    fill: "#00a000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C10.4477 1 10 1.44772 10 2V14C10 14.5523 10.4477 15 11 15H13C13.5523 15 14 14.5523 14 14V2C14 1.44772 13.5523 1 13 1H11Z",
    fill: "#00a000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.c56c6dcf38492d65a5d58f5a6ae323dc.svg";
export { ForwardRef as ReactComponent };